export const quote = (str) => I18n.locale === 'de' ? `„${str}“` : `“${str}“`

export const truncate = (text, {length}) => {
  return (text.length > length) ? `${text.substring(0, length)}…` : text
}
